// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { fromJS } from 'immutable'
import { UPDATE_PATH_VALIDATIONS_DRAWER } from './types'
import initialState from './initialState'

const pathValidationsDrawer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PATH_VALIDATIONS_DRAWER :
      return state.merge(
        fromJS(action.data)
      )

    default :
      return state
  }
}

export default pathValidationsDrawer
